import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SECTORS } from "../data/content";
import { Reveal } from "../lib/motion";
import PageHero from "../components/PageHero";
import SectorMarquee from "../components/SectorMarquee";

export default function Sectors() {
  return (
    <div data-testid="sectors-page">
      <PageHero
        overline="Industries we serve"
        title="Sectors"
        subtitle="From classrooms to clean rooms, shop floors to shopping malls - our mechanised, process-led services adapt to the standards each environment demands."
      />

      <SectorMarquee />

      <section className="mx-auto max-w-[1400px] px-5 py-20 md:px-10 md:py-28">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SECTORS.map((s, i) => (
            <Reveal key={i} delay={(i % 3) * 0.06}>
              <div data-testid={`sector-${i}`} className="group relative aspect-[4/5] overflow-hidden rounded-2xl border border-white/10">
                <img src={s.image} alt={s.name} className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/25 to-transparent" />
                <div className="absolute bottom-0 w-full p-6">
                  <h3 className="font-display text-2xl md:text-3xl font-bold tracking-tight">{s.name}</h3>
                  <p className="mt-1 text-sm text-neutral-300">{s.detail}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-16 flex flex-col items-start gap-6 rounded-2xl border border-white/10 bg-[#0a0a0a] p-10 md:flex-row md:items-center md:justify-between md:p-14">
          <div>
            <h2 className="font-display text-3xl md:text-4xl font-black tracking-tight">Don&apos;t see your sector?</h2>
            <p className="mt-3 max-w-xl text-neutral-400">We tailor manpower and facility programs to any environment. Tell us your requirement.</p>
          </div>
          <Link to="/contact" data-testid="sectors-cta" className="inline-flex items-center gap-2 rounded-full bg-accent px-6 py-3.5 text-sm font-bold text-black transition-transform duration-200 hover:scale-[0.97]">
            Talk to us <ArrowUpRight size={16} />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
